import TextField from '@mui/material/TextField';
import AppAutocomplete from 'components/FormElements/AppAutocomplete';
import { useFunds } from 'hooks/data/fund/useFunds';
import { useSortTranches } from 'hooks/ui/useSortTranches';
import { FundStatus } from 'adminConstants/fundProperties';

type TrancheOption = {
  _id: string;
  label: string;
};

type Props = {
  firmId?: string;
  selectedTranche?: Pick<TrancheOption, '_id'>;
  placeholder?: string;
  clearable?: boolean;
  maxWidth?: number;
  openOnly?: boolean;
  onChange: (trancheOption: TrancheOption | null) => void;
};

const TrancheSelector: React.FC<Props> = ({
  selectedTranche,
  onChange,
  firmId,
  maxWidth,
  placeholder = 'Tranche',
  clearable,
  openOnly,
}) => {
  const { tranches } = useFunds({
    firmId,
    leanResponse: true,
    ...(openOnly ? { fundStatus: [FundStatus.OPEN] } : {}),
  });
  const sortedTranches = useSortTranches(tranches?.data);

  const selectedValue =
    sortedTranches.find((tranche) => tranche._id === selectedTranche?._id) ??
    null;

  return (
    <AppAutocomplete
      style={{ ...(typeof maxWidth === 'number' && { maxWidth }) }}
      loading={tranches.isLoading}
      id="trancheId"
      name="trancheId"
      disableClearable={!clearable}
      options={sortedTranches}
      getOptionLabel={(option) =>
        sortedTranches.find((tranche) => tranche._id === option._id)?.label ??
        ''
      }
      getOptionKey={(option) => option._id}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      value={selectedValue}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" placeholder={placeholder} />
      )}
    />
  );
};

export default TrancheSelector;
